<template>
  <SkeletonRoot
    v-for="(_, index) in 10"
    :delay="Math.floor(index / (deviceType === 'MOBILE' ? 2 : 5))"
  >
    <Skeleton
      aspect-ratio="1"
    />
    <div :style="{ padding: '12px 8px' }">
      <Skeleton height="32px" />
      <div :style="{ display: 'flex', justifyContent: 'space-between', marginTop: '12px' }">
        <Skeleton
          height="24px"
          width="80px"
        />
        <Skeleton
          height="24px"
          width="45px"
        />
      </div>
    </div>
  </SkeletonRoot>
</template>

<script setup>
import { SkeletonRoot, Skeleton } from '@/components/Skeleton'
import { useDevice } from '@/hooks/useDevice'

const { deviceType } = useDevice()
</script>

<style lang="less">
</style>
